// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","oppositeGenderLink":"dFqQ4 hRgdS u-h9X","chevron":"zT1rC","link":"-xKKZ U6k72 hRgdS"};